import type { BlockHeading } from 'shared-types';

type LocaleData = BlockHeading['locales'][string];

const defaultBlockData = {
  format: 'html' as const,
  headingLevel: 'H2' as const
};

const translatable: LocaleData['translatable'] = {
  text: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockHeadingData: BlockHeading = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockHeading['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
